<template lang="pug">
  layout()
    //- Content
    template(v-slot:content)
      section.section: .container

        //- .card.mb-20(v-for="comment in comments" :key="comment.id"): article.media.card-content
          figure.media-left
            ui-avatar.is-64x64(:user="comment.user")
          .media-content
            .content
              p
                strong {{ comment.user.first_name }} {{ comment.user.last_name }}
                br
                | {{comment.message}}
                br
                small <a>Ответить</a> · 3 hrs


            article.media(v-for="comment in comments" :key="comment.id")
              figure.media-left
                ui-avatar.is-48x48(:user="comment.user")
              .media-content
                .content
                  p
                    strong {{ comment.user.first_name }} {{ comment.user.last_name }}
                    br
                    | {{comment.message}}
                    br
                    small <a>Ответить</a> · 3 hrs
        .card: .card-content.article.media
          figure.media-left
            ui-avatar.is-64x64(:user="user.$")
          .media-content: .content
            .field: .control
              textarea(class="textarea" placeholder="Комментарий или вопрос...")
            .field: .control
              button.button.is-primary Отправить комментрий

</template>

<script>
import { mapGetters } from 'vuex';

const msg = [
  'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis porta eros lacus, nec ultricies elit blandit non. Suspendisse pellentesque mauris sit amet dolor blandit rutrum. Nunc in tempus turpis.',
  'Donec sollicitudin urna eget eros malesuada sagittis. Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas. Aliquam blandit nisl a nulla sagittis, a lobortis leo feugiat.',
  'Vivamus quis semper metus, non tincidunt dolor. Vivamus in mi eu lorem cursus ullamcorper sit amet nec massa.',
  'Morbi vitae diam et purus tincidunt porttitor vel vitae augue. Praesent malesuada metus sed pharetra euismod. Cras tellus odio, tincidunt iaculis diam non, porta aliquet tortor.',
  'Sed convallis scelerisque mauris, non pulvinar nunc mattis vel. Maecenas varius felis sit amet magna vestibulum euismod malesuada cursus libero. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia Curae; Phasellus lacinia non nisl id feugiat.',
];
const users = ['Иван Петров', 'Ирина Антоновна', 'Екатерина Сергеевна'];
const rand = max => Math.floor(Math.random() * max);
const randObj = obj => obj[rand(obj.length)];
let _id = 0;
const comment = () => {
  let user = randObj(users).split(' ');
  return {
    id: ++_id,
    user: { first_name: user[0], last_name: user[1] },
    message: randObj(msg),
  };
};

export default {
  data: () => ({
    comments: [comment(), comment(), comment(), comment(), comment(), comment(), comment()],
  }),

  computed: {
    ...mapGetters(['user']),
  },

  created() {},
};
</script>

<style lang="scss">
.media-content > .content {
  max-width: 800px;
}
</style>
